import type { KeyboardEvent } from "react";
import { EditorSection } from "@/components/ListingFields/EditorSectionHeader";
import { TitleField, titleFieldCopy } from "@/components/ListingFields/TitleField";

const LISTING_TYPE = "product" as const;

export interface ProductTitleEditorProps {
  /** Field error for the title input, or undefined when valid. */
  error?: string;
  /** Called with the new value on every field change. */
  onChange: (value: string) => void;
  /** Key handler; the container uses it to save on Enter. */
  onKeyDown?: (event: KeyboardEvent) => void;
  /** Current value of the title field. */
  value: string;
}

export function ProductTitleEditor({ error, onChange, onKeyDown, value }: ProductTitleEditorProps) {
  return (
    <EditorSection {...titleFieldCopy(LISTING_TYPE)}>
      <TitleField error={error} listingType={LISTING_TYPE} onChange={onChange} onKeyDown={onKeyDown} value={value} />
    </EditorSection>
  );
}
